export const STATUS_OPTIONS = [
  { value: 'in_progress', label: 'In Progress' },
  // { value: 'sent', label: 'Sent' },
  // { value: 'viewed', label: 'Viewed' },
  { value: 'initial_acceptance', label: 'Accepted' },
  { value: 'accepted', label: 'Signed' },
  // { value: 'declined', label: 'Declined' },
  { value: 'voided', label: 'Voided' },
  { value: 'archived', label: 'Archived' },
];

export const QUOTE_TYPES = [
  { value: 1, label: 'CAPEX' },
  { value: 2, label: 'OPEX' },
  { value: 4, label: 'ENERDS' },
];

export const selectMenuStyles = {
  menu: (provided) => ({ ...provided, zIndex: 2 }),
};
